import { FC } from "react";
import { Dialog, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ModalStateDialogComponentProps } from "../../interface";

const ModalStateDialogComponent: FC<ModalStateDialogComponentProps> = ({
  footerContent,
  modelContent,
  isVisible,
  width = "fit-content",
  minWidth,
  id,
  headerTitle,
  onCancel,
  modalPadding,
  height,
  disableCrossIcon = false,
  footerBorderTop = false,
  headerColor = "var(--light-blue-tag)",
  zindex,
}) => {
  const handleCloseButtonClick = () => {
    onCancel?.();
  };

  const computedPadding = Number(modalPadding ?? 24);

  return (
    isVisible && (
      <Dialog
        id={id}
        open={true}
        onClose={(event: object, reason: string) => {
          if (reason === "backdropClick") {
            return;
          }
          handleCloseButtonClick();
        }}
        maxWidth="xl"
        disableEscapeKeyDown
        keepMounted
        disableEnforceFocus={true}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "var(--background-scrim)",
            },
          },
        }}
        sx={{
          zIndex: (theme) => zindex || `${(theme.zIndex.modal || 2000) + 1} !important`,
          "& .MuiPaper-root": {
            width: width,
            minWidth: minWidth,
            height: height || "auto",
            borderRadius: 1,
          },
        }}
      >
        {headerTitle && (
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              fontSize: "1.5rem",
              fontWeight: 600,
              lineHeight: "1.875rem",
              paddingInlineStart: `${computedPadding}px`,
              paddingInlineEnd: `${computedPadding - 8}px !important`,
              paddingTop: `${computedPadding / 2}px !important`,
              paddingBottom: `${computedPadding / 2}px !important`,
              background: headerColor,
              color: "var(--primary-text)",
              width: "100%",
              gap: "24px",
            }}
            data-testid="modalHeaderTitle"
          >
            {headerTitle}
            {!disableCrossIcon && (
              <IconButton onClick={(e)=>{
                e.stopPropagation()
                handleCloseButtonClick()
                }} data-testid="modalCloseIcon">
                <CloseIcon sx={{ color: "var(--primary-text)" }} />
              </IconButton>
            )}
          </DialogTitle>
        )}

        <DialogContent
          sx={{
            paddingInlineStart: `${computedPadding}px !important`,
            paddingInlineEnd: `${computedPadding}px !important`,
            paddingTop: `${computedPadding}px !important`,
            padding: 0,
            paddingBottom: `${computedPadding / 2}px`,
          }}
          data-testid="modalContent"
        >
          {modelContent}
        </DialogContent>

        {footerContent && (
          <div
            data-testid="modalFooter"
            style={{
              paddingInlineStart: `${computedPadding}px`,
              paddingInlineEnd: `${computedPadding}px`,
              paddingBottom: `${computedPadding / 2 + 4}px`,
              paddingTop: `${computedPadding / 2}px`,
              borderTop: footerBorderTop ? "solid 1px #E8F1FC" : 0,
            }}
          >
            {footerContent}
          </div>
        )}
      </Dialog>
    )
  );
};

export default ModalStateDialogComponent;
